import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_sidebar/orientamento')({
  beforeLoad: () => {
    if (import.meta.env.VITE_SURVEY_ENABLED !== 'true') {
      throw redirect({ to: '/' });
    }
  },
  component: () => <Outlet />,
});
